module.exports = __webpack_public_path__ + "media/images/categories/icon_cat22-abe28212cc06b769e3429a9e91529521.svg";